import React from 'react';
import { Dropdown, MenuProps, Space } from 'antd';
import COButton from '../COButton';
import Styles from './CODropdownButton.module.scss';
import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';
import { DropdownPlacement, DropdownTriggerType } from 'enums/CODropdownEnums';
import { ReactComponent as PlusIcon } from 'assets/icons/add.svg';

interface DropdownItem {
  value: string;
  icon: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

interface Props {
  children: React.ReactNode;
  items: DropdownItem[];
  menuPlacement?: DropdownPlacement;
  disabled?: boolean;
}

const CODropdownButton = ({
  children,
  items,
  menuPlacement = DropdownPlacement.BOTTOM_RIGHT,
  disabled = false,
}: Props) => {
  const menuItems: MenuProps['items'] = items?.map((item, index) => ({
    key: index,
    label: (
      <COButton
        disabled={item.disabled}
        text
        onClick={item.onClick}
        icon={item.icon}>
        {item.value}
      </COButton>
    ),
  }));
  return (
    <div className={Styles.dropdownBtn}>
      <Dropdown
        menu={{ items: menuItems }}
        placement={menuPlacement}
        trigger={[DropdownTriggerType.CLICK]}
        overlayClassName={Styles.dropdownMenu}>
        <COButton disabled={disabled}>
          <Space>
            <PlusIcon />
            {children}
            <Arrow fontSize={50} />
          </Space>
        </COButton>
      </Dropdown>
    </div>
  );
};

export default CODropdownButton;
